import { Skeleton, Td, Tr } from '@chakra-ui/react';
import { SkeletonProps } from '@chakra-ui/skeleton';
import React from 'react';

interface Props extends SkeletonProps {
    count: number;
}

export const Skeletons = ({ count, ...props }: Props) => (
    <>
        {Array.from({ length: count }).map((_, index) => (
            <Skeleton key={index} {...props} />
        ))}
    </>
);

export const TrSkeletons = ({ count, ...props }: Props) => (
    <Tr>
        {Array.from({ length: count }).map((_, index) => (
            <Td key={index}>
                <Skeleton key={index} {...props} />
            </Td>
        ))}
    </Tr>
);
